import { useIntersectionObserver } from 'src/common/hooks/useIntersectionObserver'
import { useAnalytics } from 'src/common/analytics'
import Section from 'src/components/shared/Section'
import Img from 'src/components/shared/Img'
import NextLink from 'next/link'

export const onViewH2Id = 'addr-member-section'

const AcdrSection = () => {
  const { track } = useAnalytics()
  const { ref } = useIntersectionObserver({
    threshold: 0.8,
    freezeOnceVisible: true,
    onChange: (isIntersecting) => {
      if (!isIntersecting) return
      track(
        { additional_info: { section: onViewH2Id }, event_type: 'track' },
        {},
        'section_view'
      )
    },
  })

  return (
    <Section className="bg-blue-390">
      <div
        className="w-full font-ultramarine text-gray-555"
        data-testid="facts-acdr-content"
      >
        <h2
          ref={ref}
          className="mb-primary-md text-center text-heading-3 font-bold leading-[31.2px] lg:mb-14 lg:text-heading-2 lg:leading-[41.6px]"
          data-testid="facts-acdr-title"
        >
          Leading the way in debt relief
        </h2>
        <div
          className="flex flex-col gap-[10px] lg:flex-row lg:gap-primary-md"
          data-testid="facts-acdr-member-list"
        >
          <div
            className="flex flex-col items-center gap-[18px] rounded-[10px] border border-blue-390 bg-[#F5F9FF] px-[22px] py-primary-md lg:w-[527px] lg:gap-primary-md lg:px-primary-md lg:py-primary"
            data-testid="facts-acdr-member-item"
          >
            <NextLink
              href="https://acdr.org/"
              target="_blank"
              prefetch={false}
              shallow={true}
              data-testid="facts-acdr-member-link"
            >
              <Img
                src="/next-assets/acdr-logo.svg"
                alt="aadr logo"
                width={182}
                height={150}
                className="h-25 w-[122px] lg:h-[150px] lg:w-45"
                layout="intrinsic"
              />
            </NextLink>
            <div
              className="w-full text-heading-4 font-bold leading-[23.4px] lg:text-heading-3 lg:leading-[31.2px]"
              data-testid="facts-acdr-member-title"
            >
              We go above and beyond to raise industry standards
            </div>
            <p
              className="text-14 leading-[19.6px] text-[#42546B] lg:text-body-medium lg:leading-[22.4px]"
              data-testid="facts-acdr-member-description"
            >
              Freedom Debt Relief is a founding, accredited member of the
              Association for Consumer Debt Relief (ACDR). Through the ACDR
              accreditation process, our practices are audited semi-annually to
              ensure we not only meet federal and state regulations but also
              uphold ACDR’s higher standards.
            </p>
          </div>
          <div
            className="lg:pt-23 flex flex-col items-center gap-[18px] rounded-[10px] border border-blue-390 bg-[#F5F9FF] px-[22px] py-primary-md lg:w-[527px] lg:gap-primary-md lg:px-primary-md lg:pb-primary"
            data-testid="facts-acdr-member-item"
          >
            <NextLink
              href="https://finhealthnetwork.org/"
              target="_blank"
              prefetch={false}
              shallow={true}
              data-testid="facts-acdr-member-link"
            >
              <Img
                src="/next-assets/fhn-logo.svg"
                alt="aadr logo"
                width={496}
                height={103}
                className="lg:w-124 h-[61px] w-full lg:h-[103px]"
                layout="intrinsic"
              />
            </NextLink>
            <div
              className="w-full text-heading-4 font-bold leading-[23.4px] lg:text-heading-3 lg:leading-[31.2px]"
              data-testid="facts-acdr-member-title"
            >
              We put your financial health first
            </div>
            <p
              className="text-14 leading-[19.6px] text-[#42546B] lg:text-body-medium lg:leading-[22.4px]"
              data-testid="facts-acdr-member-description"
            >
              Freedom Debt Relief is a member of the Financial Health Network, a
              nonprofit that brings together financial services innovators
              committed to helping Americans build resilience and reach their
              long‑term financial goals. As part of this community, we share
              ideas and best practices to create solutions that improve the
              financial health of people like you.
            </p>
          </div>
        </div>
      </div>
    </Section>
  )
}

export default AcdrSection
